import { ZitchaBanner } from '@as-react/common-types';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';

import { OptionalQueryOptions, QueryApiOptions } from '../../types/types';

import { getBanner, type ZitchaBannersParams } from './zitcha.api';

export const zitchaQueryKeys = {
  all: () => ['zitcha'] as QueryKey,
  banners: ({ placement }: ZitchaBannersParams) => [...zitchaQueryKeys.all(), 'banners', placement] as QueryKey,
};

export const zitchaQueries = (apiOptions: QueryApiOptions) => ({
  getBanner: <TReturnData>(
    placement: ZitchaBannersParams,
    options: OptionalQueryOptions<ZitchaBanner | null, TReturnData> = {}
  ) =>
    ({
      ...options,
      queryKey: zitchaQueryKeys.banners(placement),
      queryFn: () => getBanner(apiOptions, placement),
    }) as UseQueryOptions<ZitchaBanner | null, Error, TReturnData>,
});
